import { Directive, HostListener, input } from '@angular/core';
import { AudioEffectPlayer, TAudioEffect } from '../utils/audio.utils';

// Effects that only accompany an element appearing; muted when REDUCED_AUDIO is enabled.
const DECORATIVE_EFFECTS: TAudioEffect[] = ['BUBBLE_POP', 'SHORT_SLIDE'];

@Directive({
  selector: '[ridSfx]',
})
export class RidSfxDirective {
  effect = input.required<TAudioEffect>({ alias: 'ridSfx' });
  animations = input<string[]>(['pop-in'], { alias: 'ridSfxAnimations' });
  /** Overrides whether the effect counts as decorative; defaults to `DECORATIVE_EFFECTS`. */
  decorative = input<boolean | undefined>(undefined, { alias: 'ridSfxDecorative' });

  @HostListener('animationstart', ['$event'])
  onAnimationStart(event: AnimationEvent) {
    // animationstart bubbles; ignore animations of descendants (e.g. each typed card popping in).
    if (event.target !== event.currentTarget) {
      return;
    }

    if (this.animations().includes(event.animationName)) {
      const decorative = this.decorative() ?? DECORATIVE_EFFECTS.includes(this.effect());
      AudioEffectPlayer.play(this.effect(), { decorative });
    }
  }
}
